import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "drag-el__text" }
const _hoisted_2 = { class: "drag-el__count" }
const _hoisted_3 = { class: "drag-el__text" }

import { computed, inject } from "vue";
import { DragGeneralState } from "@/models/interfaces/file/file-model";
import AppIcon from "../ui-kit/icon/AppIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileDragElement',
  setup(__props) {

const dragGeneralState = inject<DragGeneralState>("dragGeneralState", {
  name: "",
  type: "",
  count: 0,
  active: false,
  x: 0,
  y: 0,
});

const typeIconMap: Record<string, string> = {
  // папка
  folder: "folder-closed",

  // документы
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  xlsm: "file-excel",
  xlsb: "file-excel",
  xltx: "file-excel",
  xltm: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  ppsx: "file-powerpoint",
  potx: "file-powerpoint",
  pdf: "file-pdf",

  // изображения
  jpg: "file-image",
  jpeg: "file-image",
  png: "file-image",
  gif: "file-image",
  bmp: "file-image",
  tiff: "file-image",
  svg: "file-image",
  ai: "file-image",
  eps: "file-image",
  webp: "file-image",
  raw: "file-image",
  psd: "file-image",
  ico: "file-image",

  // видео
  mp4: "file-video",
  mov: "file-video",
  mkv: "file-video",
  avi: "file-video",
  wmv: "file-video",
  flv: "file-video",
  webm: "file-video",
  mpeg: "file-video",
  mpg: "file-video",

  // аудио
  mp3: "file-audio",
  wav: "file-audio",
  flac: "file-audio",
  ogg: "file-audio",
  m4a: "file-audio",
  wma: "file-audio",
  ape: "file-audio",
  mid: "file-audio",
  opus: "file-audio",

  // архивы
  zip: "file-archive",
  rar: "file-archive",
  "7z": "file-archive",
  tar: "file-archive",
  gz: "file-archive",
  gzip: "file-archive",
  cab: "file-archive",
  sit: "file-archive",

  // текст
  txt: "file-text",
  log: "file-text",
  csv: "file-text",
  odt: "file-text",
  rtf: "file-text",
  epub: "file-text",
  fb2: "file-text",
  mobi: "file-text",

  // код
  html: "file-code",
  htm: "file-code",
  php: "file-code",
  asp: "file-code",
  jsp: "file-code",
  xhtml: "file-code",
  xml: "file-code",
  css: "file-code",
  js: "file-code",
};

const dragIconName = computed(() => {
  return typeIconMap[dragGeneralState.type] || "file-universal";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "drag-preview",
      class: "drag-el",
      style: _normalizeStyle({
        left: _unref(dragGeneralState).x + 'px',
        top: _unref(dragGeneralState).y + 'px',
      })
    }, [
      _createVNode(AppIcon, {
        class: "drag-el__icon",
        name: dragIconName.value,
        width: "18px",
        color: "#979797",
        cursor: "pointer"
      }, null, 8, ["name"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(dragGeneralState).name), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(dragGeneralState).count), 1)
    ], 4),
    (_unref(dragGeneralState).count > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "drag-el",
          style: _normalizeStyle({
        zIndex: 99,
        left: _unref(dragGeneralState).x + 4 + 'px',
        top: _unref(dragGeneralState).y + 4 + 'px',
      })
        }, [
          _createVNode(AppIcon, {
            class: "drag-el__icon",
            name: dragIconName.value,
            width: "18px",
            color: "#979797",
            cursor: "pointer"
          }, null, 8, ["name"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(dragGeneralState).name), 1)
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})